/*
 * Ensure that the list of domains for the retailer includes any affiliate
 * link domain rewrites, e.g., bestbuy.com gets rewritten to bestbuy.7tiv.net.
 * Duet only sees the rewritten links from WordPress.
 */
export default [
  { name: "Amazon", domains: ["amazon.com"] },
  {
    name: "Walmart Affiliate Program",
    domains: ["walmart.com", "goto.walmart.com"],
  },
  { name: "Google Store NA", domains: ["store.google.com", "anrdoezrs.net"] },
  {
    name: "Ninjakitchen",
    domains: ["ninjakitchen.com", "ninjakitchen.pxf.io"],
  },
  { name: "Samsung", domains: ["samsung.com", "howl.com"] },
  {
    name: "LEGO Brand Retail (US)",
    domains: ["lego.com", "click.linksynergy.com"],
  },
  { name: "T Mobile Postpaid", domains: ["t-mobile.com", "tmobile.prf.hn"] },
  { name: "Sonos US & Canada", domains: ["sonos.com", "sonos.sjv.io"] },
  { name: "Apple United States", domains: ["apple.com", "apple.sjv.io"] },
  { name: "Best Buy", domains: ["bestbuy.com", "bestbuy.7tiv.net"] },
];
